'use strict';

var _    = require('underscore');
var $    = require('jquery');
var Core = require('../core/core.js');
var TabSubNavTool = require('./tab__subnav__group__tool.js');
var TabSubNavSelectBox = require("./tab__subnav__group__selectbox.js");
var TabSubNavToggleButton = require('./tab__subnav__group__toggle_button.js');

/**
 * Creates a Submenu Group
 *
 * @class
 */

class TabSubNavToolOptions extends Core {

    _defaults() {
        return {
            target: '.js-editor'
        };
    }

    constructor(options) {
        super(options);

        this.template = `<div class="editor__tab__subnav__tool__options js-editor__tab__subnav__tool__options float"></div>`;

        super.render();
    }

    /**
     * Adds a a tool to the submenu group
     *
     * @param {String} name - name for the tool
     * @param {String} description
     * @param {String} icon - icon string
     * @param {Integer} weight - higher weight = last position
     */

    addButton(name, description, icon){
        var subnavtool = new TabSubNavTool({
            target: this.$el,
            fields: {
                'name': name,
                'description': description,
                'icon': icon,
            }
        });

        return subnavtool;
    }

    addSelectBox(name, description, list, initValue){
        var subnavtool = new TabSubNavSelectBox({
            target: this.$el,
            fields: {
                'name': name,
                'description': description,
                'list': list,
                'initValue': initValue
            }
        });

        return subnavtool;
    }

    clear(){
        $(this.$el).empty();
    }
}
module.exports = TabSubNavToolOptions;
